import { CerFormView } from "@form/cer-form-view";

export class CerFormPaneView {

  public id: string;
  public title: string;
  public view: CerFormView;
  public visible: boolean;
  public mandatory: boolean;
  public activate?: boolean = null;
  public content?: string = null;
  

  constructor(view: CerFormView) {
    this.id = view.id;
    this.title = view.title;
    this.view = view;
    this.visible = view.visibleDefault != 'hide';
    this.mandatory = view.mandatory;
    this.activate = (view.autoFocus == 'active') || (view.autoFocus == 'default' && view.dataChild !== true);
    }  
}
